import {post} from '@/utils/request';
import {erpplatserver,erpserver,attendanceserver} from '@/utils/baseUrl';




//考勤方案列表
export async function getKqList(params) {
    return post(attendanceserver+'/kq/getKqList', params, true)
}